module.exports = __webpack_public_path__ + "img/swl-office.3277ff5a.png";